import compose from 'lodash/flowRight'
import {connect} from 'react-redux'
import type {EntryPointProps} from 'react-relay'

import withStatusSubscription from '../../../../hocs/withStatusSubscription'
import type {State} from '../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../selectors'
import {parseBranch} from '../../../../utils/branchNames'
import type {TestsPreviewPanelCountsQuery} from '../../../packages/Tests/TestsPreviewPanel/__generated__/TestsPreviewPanelCountsQuery.graphql'

import BuildOverviewTab from './BuildOverviewTab'
import type {OuterProps, OwnProps, StateProps} from './BuildOverviewTab.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {buildId} = props
  const build = getBuild(state, buildId)
  const branch = !build?.defaultBranch ? parseBranch(build?.branchName) : null
  const buildType = getBuildType(state, build?.buildType)
  return {
    branch,
    buildTypeId: build?.buildType,
    buildTypeInternalId: buildType?.internalId,
    queued: build?.state === 'queued',
    finished: build?.state === 'finished',
    composite: build?.composite ?? false,
  }
}

const connector = connect(mapStateToProps)

const BuildOverviewTabContainer = compose(connector, withStatusSubscription())(BuildOverviewTab)
type Queries = {
  testCounts: TestsPreviewPanelCountsQuery
}
export default function BuildOverviewTabOuterContainer({
  queries,
  props,
}: EntryPointProps<Queries, {}, OuterProps, {}>) {
  return <BuildOverviewTabContainer {...props} testCountsQuery={queries.testCounts} />
}
export type BuildOverviewTabOuterContainerComponent = typeof BuildOverviewTabOuterContainer
